// Test Ids
export const permissionsPanelEntryPointTestId: string = 'permissionsTestId';
export const permissionsPanelTextTestId: string = 'permissionsTextTestId';
export const permissionsPanelCopyTestId: string = 'permissionsCopyTestId';

export const fluidLeapTestId = 'fluidLeapTestId';

export const lastEditedTestId = 'lastEditedTestId';

/**
 * Allows us to use the querySelector for the CoauthorGallery control from the acui-collab package.
 * It will be used for the `dataAutomationType` prop.
 */
export const coauthorGalleryDataAutomationType = 'coauthorGalleryDataAutomationType';
